import curator from "./curator/ApiCalls";
import bidder from "./bidder/ApiCalls";
import general from "./general/ApiCalls";

export const Curator = curator;
export const Bidder = bidder;
export const General = general;
